/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import GenerateDescription from "../utils/GenerateDescription";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [publishedOn, setPublishedOn] = useState(null);
  const [email, setEmail] = useState(null);
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [category, setCategory] = useState("event");
  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [newsStatus, setEventStatus] = useState(1);
  const [expo, setExpo] = useState(0);
  const [description, setDescription] = useState(null);
  const newsRoutes = "/data/news";
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setEmail(null);
    setPayLink(null);
    setExpo(0);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setFeatured(0);
    setDescription(null);
  };

  const responses = (error, message) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneNewsHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      published_on: publishedOn,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      category: category.toString().toLowerCase().replace(/\s/g, "_"),
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_ad: "none",
      country_short: "none",
      status: newsStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.NEWS,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  // compact design tokens (visual-only)
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-3 sm:p-4";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: newsRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `Add News`, name: entry_label }} />
        </div>

        <form onSubmit={addOneNewsHandler} className="space-y-4">
          {/* Alerts & Uploader */}
          <div className={`${card} ${sectionPad}`}>
            <div className="space-y-3">
              <MyMessage
                error={error}
                message={message}
                success={success}
                onExpired={() => {
                  setError(false);
                  setSuccess(false);
                }}
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage("");
                }}
              />

              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.NEWS)}
              />
            </div>
          </div>

          {/* News Details */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "News Details" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "published_on",
                  title: "Published On",
                  type: "date",
                  value: publishedOn ? publishedOn : "",
                  onChange: (e) => {
                    setPublishedOn(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "category",
                  title: "Category",
                  required: true,
                  option: [
                    "event",
                    "attraction",
                    "art",
                    "best of africa",
                    "book",
                    "cinema",
                    "city guide",
                    "classes",
                    "dance",
                    "food",
                    "getting around",
                    "hotel",
                    "ministry",
                    "movie",
                    "museum",
                    "music",
                    "neighborhood",
                    "nightlife",
                    "party",
                    "restaurant",
                    "safari",
                    "shopping",
                    "theater",
                    "things to do",
                    "tips and advice",
                  ],
                  onChange: (e) => {
                    setCategory(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Contact Info */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              <div className="flex items-center justify-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Social Contact */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp ? whatsapp : "",
                  onChange: (e) => {
                    setWhatsapp(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook ? facebook : "",
                  onChange: (e) => {
                    setFacebook(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter ? twitter : "",
                  onChange: (e) => {
                    setTwitter(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram ? instagram : "",
                  onChange: (e) => {
                    setInstagram(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube ? youtube : "",
                  onChange: (e) => {
                    setYoutube(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* More Settings */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              <Select
                props={{
                  id: "news_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  onChange: (e) => {
                    if (e.target.selectedIndex === 0) setEventStatus(1);
                    else setEventStatus(0);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  onChange: (e) => {
                    const choice = e.target.value;
                    setExpo(choice === "no" ? 0 : 1);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Description */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-between">
              <Title props={{ title: "Description" }} />
              <MyButton
                onClick={() => setShowDescriptionModal(true)}
                className={`${btnBase} ${btnPrimary}`}
              >
                Generate Description
              </MyButton>
            </div>
            <div className="mt-3">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags ? hashtags : "",
                  onChange: (e) => {
                    setHashtags(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Submit */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex items-center justify-end">
              <MyActionButton
                loading={loading}
                title="Add News"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Add;
